import { apiClient } from './api'

const params = (filters) => Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== '' && value !== undefined))

export const llmCostAccountingService = {
  overview: (filters = {}) => apiClient.get('/admin/llm-costs/overview', { params: params(filters) }),
  invocations: (filters = {}) => apiClient.get('/admin/llm-costs/invocations', { params: params(filters) }),
  receipt: (receiptId) => apiClient.get(`/admin/llm-costs/receipts/${encodeURIComponent(receiptId)}`),
}
